export default __webpack_public_path__ + "static/media/huawei_get_on.d4a2b7f7.png";